import { AboutTop } from 'components/AboutTop/AboutTop';
import withAboutPageQuery, { WithAboutPageQueryProps } from 'enhancers/withAboutPageQuery';
import withCountry from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';

type Props = WithAboutPageQueryProps & WithLanguageProps;

export const AboutPage: React.SFC<Props> = props => {
  const background =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.FAQ &&
    props.data.fetch.Common.FAQ.BackgroundColor
      ? props.data.fetch.Common.FAQ.BackgroundColor
      : '#ffffff';

  return (
    <div
      style={{
        background
      }}
    >
      <AboutTop
        loading={props.loading}
        items={
          !props.loading && props.data
            ? props.data.fetch.Country.AboutPage.AboutSections.map(
                (item, i) => ({
                  background:
                    props.data &&
                    props.data.fetch.Common.About &&
                    props.data.fetch.Common.About.Images &&
                    props.data.fetch.Common.About.Images[i] &&
                    props.data.fetch.Common.About.Images[i].Image
                      ? (props.data.fetch.Common.About.Images[i].Image as {
                          src: string;
                        }).src
                      : '',
                  content: props.getText(item.Content),
                  title: props.getText(item.Title)
                })
              )
            : undefined
        }
      />
    </div>
  );
};

export default withLanguageState(withCountry(withAboutPageQuery(AboutPage)));



// WEBPACK FOOTER //
// ./src/pages/AboutPage/AboutPage.tsx